@import './pn-sidenav-common.scss';
@import '../../../globals/main.scss';

pn-sidenav-level {
  display: block;
  flex-basis: 100%;
  &[data-level='2'] {
    padding-left: 2.5em;
    overflow: hidden;
    transition: max-height ease 0.2s;
    max-height: 40em;
    &[aria-hidden='true'] {
      max-height: 0;
    }
  }
}
